import { useState } from "react";
import axios from "axios";

export default function PracticaIot() {
  const [angulo, setAngulo] = useState(90);

  // Función para enviar el ángulo al servidor
  const enviarAngulo = async (valor) => {
    setAngulo(valor);
    try {
      await axios.post("https://fancyplus.digital/api/iot/estado", {
        estado: valor.toString()
      });
    } catch (error) {
      console.error("Error al enviar ángulo:", error);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        Control de Servomotor
      </h1>

      <p className="text-lg mb-8">
        Ángulo actual:{" "}
        <span className="font-bold text-blue-600">{angulo}°</span>
      </p>

      {/* Slider */}
      <input
        type="range"
        min="0"
        max="180"
        value={angulo}
        onChange={(e) => enviarAngulo(e.target.value)}
        className="w-64 h-2 bg-gray-300 rounded-lg cursor-pointer"
      />
    </div>
  );
}

